import React, { useState } from 'react'
import { DocFirmados } from './DocFirmados'
import { DocPorFirmar } from './DocPorFirmar'

export const NavDocumentos = () => {

    const [ navDoc, setNavDoc] = useState(false)

    // console.log(navDoc)

  return (



    <>

    <div className='contenedorNav'>


        <div onClick={ () => setNavDoc(false)} className={`navDoc navDocLeft ${ !navDoc && 'active' }`}>

            <p>Documentos Por Firmar</p>
       
        </div>

        <div onClick={ () => setNavDoc(true)}  className={`navDoc navDocRight ${ navDoc && 'active' }`}>

            <p>Documentos Firmados</p>

        </div>



    </div>

    {   !navDoc ?  <DocPorFirmar/> : <DocFirmados/>}

    </>
  )
}
